import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';
import { URL,api } from '../../api';
import Modalsenttouser from '../adminfaculty/Modalsenttouser';
import Modalsenttouserex from '../adminfaculty/Modalsenttouserex';
import Modalexpercommentbackexrob2 from './Modalexpercommentbackexrob2';
import Modaldetailscomment from '../adminfaculty/Modaldetailscomment';





export default class Commentexlistforadmin extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   commentex:[],
   url:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send})
      setTimeout(() => {
        api.get('registercon/selectexpertexcommentlistforadmin/'+this.props.id_send, )
        .then(res => {
          console.log(res);
          this.setState({ commentex: res.data})
        }) 
      }, 0);
  }



  list() {
      setTimeout(() => {
        api.get('registercon/selectexpertexcommentlistforadmin/'+this.props.id_send, )
        .then(res => {
          console.log(res);
          this.setState({ commentex: res.data})
        }) 
      }, 0);
  }


    render() {
        
        return (
            <>
           <MDBTable bordered small responsive>
      <MDBTableHead color="blue-grey lighten-3" textWhite>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์บทความ</th>
          <th>ชื่อผู้ทรงคุณวุฒิ</th>
          <th>วันที่ส่งตรวจ</th>
          <th>ดูรายละเอียดผลประเมิน</th>
          <th>วันที่ส่งกลับ</th>
          <th>สถานะ ผ่าน/ปรับแก้ไข</th>
          <th>การส่งกลับ/แจ้งผู้ส่ง</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
                      {this.state.commentex.map((commentex,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        {/* <td>{commentex.fileword}</td> */}
                        <td>{commentex.fileword !== null ? <>
                            <a href={`${this.state.url+commentex.fileclosenameword}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ.word</p> </a>
                            <a href={`${this.state.url+commentex.fileclosenamepdf}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ.pdf</p> </a>
                           </>:<><MDBIcon far icon="hourglass" /></>}</td>
                           <td>{commentex.name_expert}</td>
                           <td>{commentex.date_sentexpert}</td>

                        {/* <td>{commentex.filewordcomment_bn !== null ? <>{commentex.filewordcomment_bn}</>:<><MDBIcon far icon="hourglass" /></>}</td> */}
                         <td>{commentex.comment_expert != null ? <>

                         
                            {/* <a href={`${this.state.url+commentex.filewordcomment_expert}`} target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะ</p> </a> */}
                          <Modaldetailscomment filewordcomment_expert={commentex.filewordcomment_expert} id_expert={commentex.id_expertex} id_sendarticle={commentex.id_sendarticle} />


                           </>:<><MDBIcon far icon="hourglass" /></>}</td>

                        <td>{commentex.date_senbackexpert != undefined || commentex.date_senbackexpert != null  ?<>{commentex.date_senbackexpert}</>:<><MDBIcon far icon="hourglass" /></>}</td>

                        <td>{commentex.statuscomment_expert==="1"?<><MDBIcon fas icon="check" size='2x'/>ผ่าน(ไม่มีแก้ไข)</>:<>
                        {commentex.statuscomment_expert==="2"?<>ผ่าน(มีแก้ไข)</>:<> {commentex.statuscomment_expert==='0'?<>เห็นควรปรับแก้ไขและดำเนินการส่งใหม่</>:<><MDBIcon far icon="hourglass" /></>}</>}   
                            </>}
                        </td>
                        <td>{commentex.statuscomment_experten === null ?<>
                            <MDBIcon far icon="hourglass" /> อยู่ระหว่างดำเนินการ
                        </>:<>
                          {commentex.status_showex === '1'?<>  
                          ส่งกลับแล้ว
                         </>:<>
                          {/* <MDBIcon far icon="hourglass" /> อยู่ระหว่างดำเนินการ */}
                          {commentex.statuscomment_expert != null?<>
                          {commentex.statuscomment_expert === '1'?<>  <MDBIcon fas icon="check" size='2x'/></>:<> <Modalsenttouserex id_send={commentex.id_sendarticle} id_comment={commentex.id_commentex} id_bn={commentex.id_experten} list={this.list}  /></>}
                          
                          </>:<>
                          {commentex.returnbn === '1'?<>
                          <MDBIcon far icon="hourglass" /> รอบรรณาธิการพิจารณา<br/>
                          <Modalexpercommentbackexrob2 id_send={commentex.id_sendarticle} expert_id={commentex.id_expertex} id_comment={commentex.id_commentex} id_bn={commentex.id_experten} list={this.list}/>

                          </>:<> <MDBIcon far icon="hourglass" /> รอผู้ทรงคุณวุฒิพิจารณา</>}
                         
                          </>}
                         
                          </>}
                        
                        </>}
                        {}
                            
                            </td>
                        </tr>
                      )}
       
      </MDBTableBody>
    </MDBTable>
           
          </>
          
        )
    }
}


